var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "el-dialog",
    {
      attrs: {
        title: _vm.title,
        visible: _vm.dialogVisible,
        width: "400px",
        "append-to-body": true,
      },
      on: {
        "update:visible": function ($event) {
          _vm.dialogVisible = $event
        },
      },
    },
    [
      _c(
        "div",
        { staticClass: "device-select-dialog" },
        [
          _c(
            "el-select",
            {
              staticStyle: { width: "100%" },
              attrs: {
                placeholder: _vm.i18n.t("rfidwaitPleaseSelect"),
                clearable: "",
                filterable: "",
              },
              model: {
                value: _vm.selectedDevice,
                callback: function ($$v) {
                  _vm.selectedDevice = $$v
                },
                expression: "selectedDevice",
              },
            },
            _vm._l(_vm.deviceList, function (device) {
              return _c("el-option", {
                key: device.code,
                attrs: { label: _vm.i18n.t(device.label), value: device.code },
              })
            }),
            1
          ),
        ],
        1
      ),
      _c(
        "span",
        {
          staticClass: "dialog-footer",
          attrs: { slot: "footer" },
          slot: "footer",
        },
        [
          _c("el-button", { on: { click: _vm.onCancel } }, [
            _vm._v(_vm._s(_vm.i18n.t("cancel"))),
          ]),
          _c(
            "el-button",
            {
              attrs: { type: "primary", disabled: !_vm.selectedDevice },
              on: { click: _vm.onSubmit },
            },
            [_vm._v(_vm._s(_vm.i18n.t("enSure")))]
          ),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }